let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("5yNG7")]).then(() => parcelRequire('7AfLj'));